import { TRecoverRequest } from "@/features/auth/types/recoverRequest";
import { TApiRes } from "@/types/api";
import { clientApi } from "@/utils/api";

export const resendRequestResetPasswordApi = async (payload: TRecoverRequest): Promise<boolean> => {
  try {
    const {
      data: { data },
    } = await clientApi.post<TApiRes<boolean>>("/resend-request-reset-password", payload);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};
